"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpMessageSchema = exports.fileMetadataSchema = exports.projectDraftSchema = exports.httpProjectSchema = exports.projectTaskSchema = exports.taskStatusSchema = exports.projectOutlineSchema = exports.projectWorkstreamSchema = exports.workstreamDeliverableSchema = exports.WorkstreamDeliverableIcon = void 0;
const zod_1 = require("zod");
const project_update_1 = require("./project-update");
var WorkstreamDeliverableIcon;
(function (WorkstreamDeliverableIcon) {
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["hire"] = 0] = "hire";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["analysis"] = 1] = "analysis";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["iteration"] = 2] = "iteration";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["implementation"] = 3] = "implementation";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["report"] = 4] = "report";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["document"] = 5] = "document";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["strategy"] = 6] = "strategy";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["roadmap"] = 7] = "roadmap";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["training"] = 8] = "training";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["communication"] = 9] = "communication";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["audit"] = 10] = "audit";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["charter"] = 11] = "charter";
    WorkstreamDeliverableIcon[WorkstreamDeliverableIcon["design"] = 12] = "design";
})(WorkstreamDeliverableIcon || (exports.WorkstreamDeliverableIcon = WorkstreamDeliverableIcon = {}));
exports.workstreamDeliverableSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    icon: zod_1.z
        .string()
        .describe("should be one of the predefined icons, but frontend must expect this to be some unknown value"),
    description: zod_1.z.string(),
    startDate: zod_1.z.string().date().optional(),
    targetDate: zod_1.z.string().date().optional(),
    ownerId: zod_1.z.string().nullable().optional(),
});
exports.projectWorkstreamSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    deliverables: zod_1.z.array(exports.workstreamDeliverableSchema),
    ownerId: zod_1.z.string().nullable().optional(),
});
exports.projectOutlineSchema = zod_1.z.object({
    workstreams: zod_1.z.array(exports.projectWorkstreamSchema),
});
exports.taskStatusSchema = zod_1.z.enum(["done", "started", "on_hold"]);
exports.projectTaskSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    status: exports.taskStatusSchema.nullable(),
    assignee: zod_1.z.string().optional().nullable(),
    execution: zod_1.z.discriminatedUnion("targetActor", [
        zod_1.z.object({
            targetActor: zod_1.z.literal("human"),
            suggestedAssignee: zod_1.z.string().optional(),
        }),
        zod_1.z.object({
            targetActor: zod_1.z.literal("bot"),
            type: zod_1.z.enum(["schedule_meeting", "draft_document", "do_research"]),
        }),
    ]),
    workstreamId: zod_1.z.string(),
    deliverableId: zod_1.z.string().nullable(),
});
exports.httpProjectSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    outline: exports.projectOutlineSchema,
    objectives: zod_1.z.array(zod_1.z.string()).optional(), // optional for backward compatibility, todo make non-optional
    tasks: zod_1.z.array(exports.projectTaskSchema),
    confidential: zod_1.z.boolean().optional(),
    collaborators: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    creatorId: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    updates: zod_1.z.array(project_update_1.projectUpdateSchema).optional(), // optional for backward compatibility
});
exports.projectDraftSchema = zod_1.z.object({
    title: zod_1.z.string().optional(),
    objectives: zod_1.z.array(zod_1.z.string()).optional(),
    workstreams: zod_1.z.array(exports.projectWorkstreamSchema).optional(),
});
exports.fileMetadataSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
});
exports.httpMessageSchema = zod_1.z.object({
    createdAt: zod_1.z.string(),
    role: zod_1.z.enum(["user", "assistant"]),
    content: zod_1.z.string(),
    files: zod_1.z.array(exports.fileMetadataSchema),
});
